import { css } from "@stubhub/broadway-foundation/css";

export const cardsGrid = css({
  display: "grid",
  gridTemplateColumns: "[1fr]",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  marginBlock: "primitives.150",
  marginInline: "primitives.0",
  tablet: {
    gridTemplateColumns: "[repeat(2, 1fr)]",
  },
  desktop: {
    gridTemplateColumns: "[repeat(2, 1fr)]",
  },
});

export const card = css({
  backgroundColor: "bg.surface",
  borderStartStartRadius: "primitives.150",
  borderStartEndRadius: "primitives.150",
  borderEndEndRadius: "primitives.150",
  borderEndStartRadius: "primitives.150",
  overflowX: "hidden",
  overflowY: "hidden",
  boxShadow: "[0 2px 8px rgba(0, 0, 0, 0.08)]",
  transitionProperty: "[all]",
  transitionDuration: "[0.2s]",
  transitionTimingFunction: "[ease]",
  _hover: {
    boxShadow: "[0 4px 16px rgba(0, 0, 0, 0.12)]",
    transform: "[translateY(-2px)]",
  },
});

export const categoryHeaderWrapper = css({});

export const divider = css({
  borderBlockStartWidth: "primitives.25",
  borderBlockStartStyle: "[solid]",
  borderBlockStartColor: "var(--component-border-primary)",
  borderBlockEndWidth: "primitives.0",
  borderInlineStartWidth: "primitives.0",
  borderInlineEndWidth: "primitives.0",
  marginBlock: "primitives.25",
  marginInline: "primitives.50",
  opacity: "[0.2]",
});

export const eventsList = css({
  display: "flex",
  flexDirection: "column",
  transitionProperty: "[max-height, opacity]",
  transitionDuration: "[0.3s]",
  transitionTimingFunction: "[ease-in-out]",
});

export const eventItemHidden = css({
  maxHeight: "primitives.0",
  opacity: "[0]",
  overflowX: "hidden",
  overflowY: "hidden",
  transitionProperty: "[max-height, opacity]",
  transitionDuration: "[0.25s]",
  transitionTimingFunction: "[ease-out]",
});

export const eventItemVisible = css({
  maxHeight: "[150px]",
  opacity: "[1]",
  transitionProperty: "[max-height, opacity]",
  transitionDuration: "[0.25s]",
  transitionTimingFunction: "[ease-in]",
});

export const expandToggle = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "full",
  paddingBlock: "primitives.150",
  cursor: "pointer",
  color: "text.brand",
  fontWeight: "medium",
  fontSize: "[14px]",
  columnGap: "primitives.50",
  borderBlockStartWidth: "primitives.0",
  borderBlockEndWidth: "primitives.0",
  borderInlineStartWidth: "primitives.0",
  borderInlineEndWidth: "primitives.0",
  backgroundColor: "[transparent]",
  transitionProperty: "[background]",
  transitionDuration: "[0.2s]",
  transitionTimingFunction: "[ease-in-out]",
  "& [data-expand-icon]": {
    display: "inline-flex",
    alignItems: "center",
    width: "primitives.0",
    overflowX: "hidden",
    transitionProperty: "[width]",
    transitionDuration: "[0.3s]",
    transitionTimingFunction: "[ease]",
  },
  _hover: {
    backgroundColor: "bg.fill.brand",
    color: "[white]",
    "& [data-expand-icon]": {
      width: "primitives.200",
    },
  },
});
